// store/sidebarStore.js
import { create } from 'zustand';

const useSidebarStore = create((set) => ({
  selectedPath: null,
  setSelectedPath: (path) => set({ selectedPath: path }),
  clearSelectedPath: () => set({ selectedPath: null }),
}));

export default useSidebarStore;
